import React, { useState } from "react";
import "./Events.scss";

const eventsData = [
  {
    id: 1,
    title: "International Council Members – UNESCO Chair's Global Network for Medical, Health Professions and Medical Education",
    date: "25th August 2025",
    location: "Hybrid Mode (Virtual Meeting)",
    description: `The Business Meeting of the International Council Members was held in hybrid mode on 25th August 2025 bringing together Council members to review progress, discuss strategic priorities, and advance work toward a globally relevant framework for integrating bioethics into health professions education.

The meeting was opened by Prof. Vedprakash Mishra, Secretary General, who welcomed all members. Prof. Ronald Harden was installed as Chair and emphasized the increasing global importance of ethics in medical and health professions education. Prof. Russell D'Souza, Co-Chair, delivered the welcome address and formally introduced new organizational members to the Network.

Reflections from the Basel 2024 Business Meeting were presented by Prof. Madalena Patricio, highlighting the need for systematic integration of ethics into curricula, clearly defined ethical competencies, and the sharing of international best practices. The data were compiled and analysed by Prof. Surapaneni Krishna Mohan. Feedback from the Bioethics Symposium held at the World Federation for Medical Education (WFME) Conference was also presented.

A key agenda item was the discussion on the Draft Consensus Statement on the Inclusion of Bioethics in Health Professions Education, prepared by Prof. Vedprakash Mishra and Prof. Gaurav Mishra. Members agreed that a globally consulted and widely acceptable consensus statement should precede any formal declaration.

The meeting concluded with appreciation for members' active participation and a reaffirmation of the Network's shared commitment to advancing bioethics education worldwide.`,
    images: [
      "/icm-health-barcelona/word_media_image1.png",
      "/icm-health-barcelona/word_media_image2.png",
      "/icm-health-barcelona/word_media_image3.png",
    ],
  },
  {
    id: 2,
    title: "Second International Scholarship and Conference on Medical Education – Celebrating 50 Years",
    date: "4th July 2025",
    location: "Centre for Medical Education, University of Dundee, Scotland",
    description: `The Second International Scholarship and Conference on Medical Education was held on 4 July 2025 at the Centre for Medical Education, University of Dundee, celebrating 50 years of Medical Education. Prof. Russell D'Souza and Prof. Susie Schofield welcomed participants and highlighted the Centre's legacy since its founding in 1972 by Prof. Ronald Harden, whose pioneering contributions—especially the OSCE—have shaped global medical education.

The event marked the launch of the Global Network for Medical, Health Professions and Bioethics Education and showcased collaboration among leading international organizations.

A highlight of the ceremony was the conferral of the title "Lifetime Professor Emeritus" upon Professor Dr. Ronald Harden by Datta Meghe Institute of Higher Education & Research (Deemed University), India. This honor was formally bestowed by Professor Ved Prakash Mishra, Pro-Chancellor of the University and President of AMEI, on behalf of the Chancellor, Shri Dattaji Meghe.

Panel discussions were held on the contributions of professional organizations to medical education, emphasizing faculty development, assessment reform, curriculum innovation and global collaboration.`,
    images: [
      "/2nd-isc/word_media_image1.jpeg",
      "/2nd-isc/word_media_image2.jpeg",
      "/2nd-isc/word_media_image3.jpeg",
      "/2nd-isc/word_media_image4.jpeg",
      "/2nd-isc/word_media_image5.jpeg",
      "/2nd-isc/word_media_image6.jpeg",
      "/2nd-isc/word_media_image7.jpeg",
      "/2nd-isc/word_media_image8.jpeg",
      "/2nd-isc/word_media_image9.jpeg",
      "/2nd-isc/word_media_image10.jpeg",
      "/2nd-isc/word_media_image11.jpeg",
    ],
  },
  {
    id: 3,
    title: "WFME World Conference 2025 – Bangkok",
    date: "25–28 May 2025",
    location: "Centara Grand and Bangkok Convention Centre, Bangkok",
    description: `The WFME World Conference 2025 was held in Bangkok from 25–28 May 2025 at the Centara Grand and Bangkok Convention Centre, bringing together participants from across the globe to advance excellence in medical education. Numerous papers were accepted and presented by faculty members, reflecting a wide range of scholarly work and international collaboration. It was especially encouraging to see many students from the Beyond Campus Program actively participating through paper and poster presentations, contributing meaningfully to the international academic deliberations.

A key highlight of the conference was a symposium titled "A Global Consensus regarding Bioethics in the Health Professions Curriculum." The session addressed the growing global emphasis on the teaching and assessment of bioethics across health professions education.

The symposium featured perspectives from international experts and outlined the ongoing work of the Global Network for Medical, Health Professions and Bioethics Education towards developing a Consensus Statement on Bioethics in Medical Education. The proposed themes will be reviewed by the Network's members and the regional bodies of the World Federation for Medical Education (WFME).`,
    images: [
      "/wfme-bangkok/word_media_image1.jpeg",
      "/wfme-bangkok/word_media_image2.jpeg",
      "/wfme-bangkok/word_media_image3.png",
      "/wfme-bangkok/word_media_image4.jpeg",
      "/wfme-bangkok/word_media_image5.jpeg",
      "/wfme-bangkok/word_media_image6.jpeg",
      "/wfme-bangkok/word_media_image7.jpeg",
      "/wfme-bangkok/word_media_image8.jpeg",
      "/wfme-bangkok/word_media_image9.jpeg",
      "/wfme-bangkok/word_media_image10.jpeg",
      "/wfme-bangkok/word_media_image11.jpeg",
      "/wfme-bangkok/word_media_image12.jpeg",
      "/wfme-bangkok/word_media_image13.jpeg",
      "/wfme-bangkok/word_media_image14.jpeg",
      "/wfme-bangkok/word_media_image15.jpeg",
      "/wfme-bangkok/word_media_image16.jpeg",
    ],
  },
];

function Events() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentEventImages, setCurrentEventImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const openLightbox = (images, index) => {
    setCurrentEventImages(images);
    setCurrentImageIndex(index);
    setSelectedImage(images[index]);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    setCurrentEventImages([]);
    setCurrentImageIndex(0);
  };

  const nextImage = (e) => {
    e.stopPropagation();
    const newIndex = (currentImageIndex + 1) % currentEventImages.length;
    setCurrentImageIndex(newIndex);
    setSelectedImage(currentEventImages[newIndex]);
  };

  const prevImage = (e) => {
    e.stopPropagation();
    const newIndex = (currentImageIndex - 1 + currentEventImages.length) % currentEventImages.length;
    setCurrentImageIndex(newIndex);
    setSelectedImage(currentEventImages[newIndex]);
  };

  return (
    <div className="events-page">
      <div className="events-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Our Events</h1>
          <p>Conferences, Symposiums & Academic Gatherings</p>
        </div>
      </div>

      <div className="events-container">
        {eventsData.map((event) => (
          <article className="event-card" key={event.id}>
            <div className="event-header">
              <h2 className="event-title">{event.title}</h2>
              <div className="event-meta">
                <span className="event-date">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                  </svg>
                  <strong>Date:</strong> {event.date}
                </span>
                <span className="event-location">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                  <strong>Venue:</strong> {event.location}
                </span>
              </div>
            </div>

            <div className="event-description">
              {event.description.split('\n\n').map((paragraph, idx) => (
                <p key={idx}>{paragraph}</p>
              ))}
            </div>

            <div className="event-gallery">
              <h3 className="gallery-title">Event Gallery</h3>
              <div className="gallery-grid">
                {event.images.map((image, index) => (
                  <div
                    className="gallery-item"
                    key={index}
                    onClick={() => openLightbox(event.images, index)}
                  >
                    <img src={image} alt={`${event.title} - ${index + 1}`} />
                    <div className="gallery-overlay">
                      <span className="zoom-icon">
                        <i className="fas fa-search-plus"></i>
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <button className="lightbox-close" onClick={closeLightbox}>
            &times;
          </button>
          <button className="lightbox-nav prev" onClick={prevImage}>
            &#10094;
          </button>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage} alt="Event" />
            <div className="lightbox-counter">
              {currentImageIndex + 1} / {currentEventImages.length}
            </div>
          </div>
          <button className="lightbox-nav next" onClick={nextImage}>
            &#10095;
          </button>
        </div>
      )}
    </div>
  );
}

export default Events;
